'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { MEDIA_ATTACHMENTS_QUERY_ROOT } from '@/hooks/mediaAttachments/queryKeys';
import { useFetch } from '@/hooks/useFetch';
import type { CreateMediaAttachmentRequest, CreateMediaAttachmentResponse } from '@/types/mediaAttachmentsApiTypes';

export function useCreateMediaAttachmentMutation() {
  const queryClient = useQueryClient();
  const { doFetch } = useFetch<CreateMediaAttachmentRequest, CreateMediaAttachmentResponse>();

  return useMutation({
    mutationFn: (body: CreateMediaAttachmentRequest) =>
      doFetch('/api/media-attachments', {
        method: 'POST',
        body,
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [MEDIA_ATTACHMENTS_QUERY_ROOT] });
    },
  });
}
